import React, { useState } from "react"
import { Grid } from "../Table"
import { v4 as uuid } from "uuid"
import { RiCheckFill, RiCloseFill, RiDeleteBin7Fill, RiPencilFill } from "react-icons/ri"
import ModalAlert from "../ModalAlert"
import { UseOdsArea } from "../../core/utils/hooks/useOdsArea"
import { Esm5w2hAction } from "../Esm5w2hAction"

const filterData = (data, search) => {
  const returnedFilter = data?.filter((item) => !search || `${item?.description}`.includes(search))

  if (search && returnedFilter.length === 0) {
    return [{ description: search, new: true, area: "", level: "", edit: true, id: uuid() }]
  }

  return returnedFilter
}

export const ActionGrid = ({
  checkbox = true,
  isDeletable = false,
  handleReloadActions,
  rows,
  setNewRow,
  setCopyRows,
  onSelectedRowsChange,
  removeAction,
  hasActionsDetails = false,
  showOnlyActions = false
}) => {
  const [is5w2hModalOpen, set5w2hModal] = useState(false);

  const odsArea = UseOdsArea()?.areas?.map((item, index) => ({
    value: index,
    label: item,
  }));

  const [search, onSearch] = useState([])

  const addAction = (e, tableManager) => {
    setNewRow(e)
    tableManager.searchApi.setSearchText("")
  }

  const handleOpen5w2hModal = (action) => {
    set5w2hModal(action);
  }
  
  const handleClose5w2hModal = () => {
    set5w2hModal(false);
    handleReloadActions();
  }

  return (
    <>
      <Grid
        isPaginated={false}
        onSearchTextChange={onSearch}
        onSelectedRowsChange={onSelectedRowsChange}
        columns={actionsGrid(
          checkbox,
          isDeletable,
          addAction,
          setCopyRows,
          rows,
          removeAction,
          odsArea,
          hasActionsDetails,
          showOnlyActions
        )}
        rows={search?.length === 0 ? rows || [] : filterData(rows || [], search)}
      />
    </>
  )
}

const optionsLevel = [
  { value: "Ruim", label: "Ruim" },
  { value: "Médio", label: "Médio" },
  { value: "Alto", label: "Alto" },
  { value: "Baixo", label: "Baixo" },
  { value: "Bom", label: "Bom" },
]

const optionsToDuplicate = [
  { label: 1, value: '1' },
  { label: 2, value: '2' },
  { label: 3, value: '3' },
  { label: 4, value: '4' },
  { label: 5, value: '5' },
  { label: 6, value: '6' },
  { label: 7, value: '7' },
  { label: 8, value: '8' },
  { label: 9, value: '9' },
  { label: 10, value: '10' },
  { label: 11, value: '11' },
  { label: 12, value: '12' },
  { label: 13, value: '13' },
  { label: 14, value: '14' },
  { label: 15, value: '15' },
  { label: 16, value: '16' },
  { label: 17, value: '17' },
  { label: 18, value: '18' },
  { label: 19, value: '19' },
  { label: 20, value: '20' },
  { label: 21, value: '21' },
  { label: 22, value: '22' },
  { label: 23, value: '23' },
  { label: 24, value: '24' },
  { label: 25, value: '25' },
  { label: 26, value: '26' },
  { label: 27, value: '27' },
  { label: 28, value: '28' },
  { label: 29, value: '29' },
  { label: 30, value: '30' },
  { label: 31, value: '31' },
  { label: 32, value: '32' },
  { label: 33, value: '33' },
  { label: 34, value: '34' },
  { label: 35, value: '35' },
  { label: 36, value: '36' },
  { label: 37, value: '37' },
  { label: 38, value: '38' },
  { label: 39, value: '39' },
  { label: 40, value: '40' },
  { label: 41, value: '41' },
  { label: 42, value: '42' },
  { label: 43, value: '43' },
  { label: 44, value: '44' },
  { label: 45, value: '45' },
  { label: 46, value: '46' },
  { label: 47, value: '47' },
  { label: 48, value: '48' },
  { label: 49, value: '49' },
  { label: 50, value: '50' },
  { label: 51, value: '51' },
  { label: 52, value: '52' },
  { label: 53, value: '53' },
  { label: 54, value: '54' },
  { label: 55, value: '55' },
  { label: 56, value: '56' },
  { label: 57, value: '57' },
  { label: 58, value: '58' },
  { label: 59, value: '59' },
  { label: 60, value: '60' },
  { label: 61, value: '61' },
  { label: 62, value: '62' },
  { label: 63, value: '63' },
  { label: 64, value: '64' },
  { label: 65, value: '65' },
  { label: 66, value: '66' },
  { label: 67, value: '67' },
  { label: 68, value: '68' },
  { label: 69, value: '69' },
  { label: 70, value: '70' },
  { label: 71, value: '71' },
  { label: 72, value: '72' },
  { label: 73, value: '73' },
  { label: 74, value: '74' },
  { label: 75, value: '75' },
  { label: 76, value: '76' },
  { label: 77, value: '77' },
  { label: 78, value: '78' },
  { label: 79, value: '79' },
  { label: 80, value: '80' },
  { label: 81, value: '81' },
  { label: 82, value: '82' },
  { label: 83, value: '83' },
  { label: 84, value: '84' },
  { label: 85, value: '85' },
  { label: 86, value: '86' },
  { label: 87, value: '87' },
  { label: 88, value: '88' },
  { label: 89, value: '89' },
  { label: 90, value: '90' },
  { label: 91, value: '91' },
  { label: 92, value: '92' },
  { label: 93, value: '93' },
  { label: 94, value: '94' },
  { label: 95, value: '95' },
  { label: 96, value: '96' },
  { label: 97, value: '97' },
  { label: 98, value: '98' },
  { label: 99, value: '99' },
  { label: 100, value: '100' },
]

const actionsGrid = (
  checkbox,
  isDeletable,
  addAction,
  setCopyRows,
  rows,
  removeAction,
  odsArea,
  showOnlyActions,
) => {

  const renderSelectOptions = (options) => {
    return options.map((item) => (
      <option key={item.value} value={item.label}>
        {item.label}
      </option>
    ));
  };

  const renderEditorSelect = (value, options, onChange, data, column) => (
    <select
      style={{ width: "100%", margin: "0 8px" }}
      value={value || ""}
      onChange={(e) => onChange({ ...data, [column.field]: e.target.value })}
    >
      {!value && <option value="" disabled>Selecione uma opção</option>}
      {renderSelectOptions(options)}
    </select>
  );

  return [
    {
      id: "checkbox",
      visible: checkbox,
    },
    {
      id: "description",
      field: "description",
      label: "Recomendação",
      width: "calc(100% - 400px)",
      cellRenderer: ({ value, data, tableManager }) => (
        <div className="rgt-cell-inner action">
          {!data.new && value}
          {data.new && !showOnlyActions && (
            <button onClick={() => addAction(data, tableManager)}>Clique para adicionar</button>
          )}
        </div>
      ),
    },
    {
      id: "title",
      field: "title",
      label: "Conformidade",
      width: "180px",
      editorCellRenderer: ({ value, data, column, onChange }) => (
        renderEditorSelect(value, optionsLevel, onChange, data, column)
      ),
    },
    /* !showOnlyActions && {
      id: "numberOfCopies",
      field: "numberOfCopies",
      label: "Número de Cópias",
      width: "150px",
      editorCellRenderer: ({ value, data, column, onChange }) => (
        renderEditorSelect(value, optionsToDuplicate, onChange, data, column)
      ),
    }, */
    /* {
      id: "Projeto",
      field: "Projeto",
      label: "Projeto",
      width: "180px",
      editorCellRenderer: ({ value, data, column, onChange }) => (
        renderEditorSelect(value, optionsLevel, onChange, data, column)
      ),
    }, */
    {
      id: "my-buttons-column",
      width: "max-content",
      pinned: true,
      sortable: false,
      resizable: false,
      cellRenderer: ({ tableManager, data }) => (
        <>
          {!data.new && data.edit && (
            <button
              title="Editar Ação"
              style={{ marginLeft: 20, border: "none", background: "none" }}
              onClick={(e) => tableManager.rowEditApi.setEditRowId(data.id)}>
              <RiPencilFill color="#FF8C02" />
            </button>
          )}
          {isDeletable && (
            <button
              style={{ marginLeft: "8px" }}
              className="rgt-cell-inner-actions"
              title="Excluir Ação"
              onClick={() =>
                ModalAlert.danger({
                  title: "Deseja Remover?",
                  confirmLabel: "Ok",
                  onConfirm: () => {
                    removeAction(data.id)
                  },
                })
              }>
              <RiDeleteBin7Fill color="red" />
            </button>
          )}
        </>
      ),
      editorCellRenderer: ({ tableManager, data, rowIndex }) => (
        <div style={{ display: "inline-flex" }}>
          {!data.new && (
            <>
              <button
                style={{ marginLeft: 20, border: "none", background: "none" }}
                onClick={(e) => tableManager.rowEditApi.setEditRowId(null)}>
                <RiCloseFill color="#FF8C02" />
              </button>
              <button
                style={{ marginLeft: 10, marginRight: 20, border: "none", background: "none" }}
                onClick={(e) => {
                  let rowsClone = [...rows]
                  let updatedRowIndex = rowsClone.findIndex((r) => r.id === data.id)
                  rowsClone[updatedRowIndex + 1] = data
                  setCopyRows(rowsClone)
                  tableManager.rowEditApi.setEditRowId(null)
                }}>
                <RiCheckFill color="#08b7348" />
              </button>
            </>
          )}
        </div>
      ),
    },
  ].filter(Boolean);
};

